import React, {Component} from 'react';

class Sounds extends Component {
    render() {
        return (
            <div>
                Sounds
            </div>
        );
    }
}

export default Sounds;